export const IsNullOrEmpty = (str) => {
  return str === null || str === undefined || str.length === 0 || str === '';
}